import { SectionWrapper } from '../components/SectionWrapper';
import { StepCard } from '../components/StepCard';

import styles from './InstitutionsPillarsSection.module.css';

const pillars = [
  {
    body: 'The usual publisher, homework, clicker, and AI stack can push students well past $100. Kudu is $25 per student per semester for the complete course platform.',
    label: 'THE COST',
    title: 'A vastly cheaper stack for the entire class.',
  },
  {
    body: 'One platform, one login, one IT review, one accessibility audit, and one support path replaces four or five disconnected contracts.',
    label: 'THE STACK',
    title: 'One partner replaces a complex vendor stack.',
  },
  {
    body: 'At $25 per student, inclusive access can break even or save money while giving every student the same textbook, homework, AI, polling, and accessibility layer.',
    label: 'THE PROGRAM',
    title: 'Inclusive access that pencils out.',
  },
] as const;

export function InstitutionsPillarsSection() {
  return (
    <SectionWrapper background="soft" data-testid="institutions-section-pillars">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>THE CASE</p>
          <h2 className={styles.title}>Three things that compound.</h2>
          <p className={styles.subhead}>
            Each idea matters on its own. Taken together — a simpler stack,
            affordable access, and faculty retention — they create momentum
            that&apos;s hard to reverse.
          </p>
        </div>
        <div className={styles.grid}>
          {pillars.map((pillar) => (
            <StepCard key={pillar.label} {...pillar} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
